import { useConnection, useWallet } from '@solana/wallet-adapter-react'

import useBalance from './useBalance'
import useSignMessage from './useSignMessage'
import useTradeProvider from './useTradeProvider'

const useSolana = () => {
  const { connected, publicKey, connecting } = useWallet()
  const { balance, getBalance, ...balanceRest } = useBalance()
  const { connection } = useConnection()
  const { signMessage } = useSignMessage()
  const tradeProvider = useTradeProvider()

  return {
    connecting,
    isConnected: connected,
    address: publicKey?.toBase58(),
    balance,
    ...balanceRest,
    connection,
    tradeProvider,
    getBalance,
    signMessage
  }
}

export default useSolana
